/**
 * Constants used by the service and locally for object diffs
 */ export class DeltaApiConstants {
}
/** Value used when a collection property is cleared of values */ DeltaApiConstants.CollectionCleanupValue = "RemoveAll";
